<template>
  <div id="app">

    <headerMode></headerMode>

    <div class="main-page">
      <router-view />
    </div>

    <footerMode></footerMode>

    <floatNav></floatNav>
  </div>
</template>

<script>
import { get, post } from '@/utils/request'
import apis from '@/utils/api'

import headerMode from '@/components/header'
import footerMode from '@/components/footer'
import floatNav from '@/components/floatNav'

export default {
  components: {
    headerMode,
    footerMode,
    floatNav
  },
  created() {
    this.getConfig()
  },
  methods: {
    getConfig() {
      get(apis.getConfig, {}, { showLoading: false }).then(res => {
        this.$store.commit('setConfig', res.data)
        if (res.data.title) {
          document.title = res.data.title
        }
        if (res.data.avatar) {
          setFavicon(res.data.avatar)
        }
      })
    },
  }
}

const setFavicon = (iconUrl) => {
  if (!iconUrl) return

  // 查找已有的 icon link 标签
  let link = document.querySelector("link[rel*='icon']")

  // 如果不存在则创建
  if (!link) {
    link = document.createElement('link')
    link.rel = 'shortcut icon'
    link.sizes = '32x32'
    document.head.appendChild(link)
  }

  // 设置图标地址（添加时间戳防止缓存）
  link.href = iconUrl + '?t=' + Date.now()
}
</script>

<style lang="scss">
@import '@/styles/reset.scss';
@import '@/styles/style.scss';

.main-page {
  min-height: 55vh;
  background-color: #efefef;
}

.el-popover-class-header-menu {
  margin-top: 0px !important;
  left: 0px !important;
}
</style>
